const setDeepObject = (object, split, value) => {
  split.reduce((acc, key, idx) => {
    if (idx === split.length - 1) {
      acc[key] = value;
      return acc;
    }
    if (!acc[key]) acc[key] = {};
    return acc[key];
  }, object);

  return object;
};

const setObjectKetValue = (object = {}, key, value) => {
  if (!key) return object; // nothing to set

  const split = key.split('.');
  // set directly, only one key
  if (split.length === 1) {
    object[key] = value;
    return object;
  }

  return setDeepObject(object, split, value);
};

export default setObjectKetValue;
